export type ContactFaq = { q: string; a: string };
export type ContactExpect = { icon: 'analytics' | 'users' | 'clock'; title: string; text: string };
export type ContactPerson = { name: string; role: string };
export type ContactBilling = { k: string; v: string };

export type ContactCopy = {
  navFeatures: string;
  navRoles: string;
  navPricing: string;
  navContact: string;
  navLogin: string;
  navCta: string;
  mobileWrite: string;
  heroTitleBefore: string;
  heroTitleHighlight: string;
  heroSub: string;
  heroCtaWrite: string;
  heroCtaSchedule: string;
  calendarMonth: string;
  calendarBadge: string;
  chatIn: string;
  chatOut: string;
  teamOnlineLabel: string;
  teamOnlineHours: string;
  formTitle: string;
  formSub: string;
  labelFirstName: string;
  labelLastName: string;
  labelEmail: string;
  labelCompany: string;
  labelSubject: string;
  labelMessage: string;
  placeholderFirstName: string;
  placeholderLastName: string;
  placeholderEmail: string;
  placeholderCompany: string;
  placeholderSubject: string;
  placeholderMessage: string;
  subjects: string[];
  submit: string;
  consent: string;
  scheduleTitle: string;
  scheduleSub: string;
  teamTitle: string;
  team: ContactPerson[];
  expectTitle: string;
  expect: ContactExpect[];
  preferTitle: string;
  emailLabel: string;
  emailValue: string;
  phoneLabel: string;
  phoneValue: string;
  phoneHref: string;
  billingTitle: string;
  billingCompany: string;
  billing: ContactBilling[];
  faqTitle: string;
  faq: ContactFaq[];
  footerTagline: string;
  footerProduct: string;
  footerCompany: string;
  footerSupport: string;
  footerLegal: string;
  footerShifts: string;
  footerAttendance: string;
  footerContracts: string;
  footerHiring: string;
  footerAbout: string;
  footerCareers: string;
  footerBlog: string;
  footerHelp: string;
  footerContact: string;
  footerStatus: string;
  footerGdpr: string;
  footerTerms: string;
  footerCookies: string;
  footerPrivacy: string;
  footerTermsShort: string;
  requiredError: string;
  sendFailed: string;
  sendSuccess: string;
};

const CS: ContactCopy = {
  navFeatures: 'Funkce',
  navRoles: 'Pro koho',
  navPricing: 'Ceník',
  navContact: 'Kontakt',
  navLogin: 'Přihlásit se',
  navCta: 'Vyzkoušet zdarma',
  mobileWrite: 'Spojit se',
  heroTitleBefore: 'Pojďme probrat\nvaše ',
  heroTitleHighlight: 'směny',
  heroSub:
    'Napište nám, nebo si rovnou vyberte termín - ozveme se do 1 pracovního dne. Žádný prodejní tlak, jen konkrétní odpovědi na to, jak si u vás Ompli poradí se směnami.',
  heroCtaWrite: 'Spojit se',
  heroCtaSchedule: 'Live chat',
  calendarMonth: 'Červenec',
  calendarBadge: '30 min',
  chatIn: 'Máme 14 brigádníků a rozpis v Excelu. Zvládne to Ompli?',
  chatOut: 'Bez problému - ukážu vám to na vašem rozpisu. Kdy se hodí?',
  teamOnlineLabel: 'Náš tým je online',
  teamOnlineHours: 'Po–Pá, 9:00 – 17:00',
  formTitle: 'Napište nám',
  formSub: 'Stačí pár řádků o tom, jak dnes plánujete směny.',
  labelFirstName: 'Jméno',
  labelLastName: 'Příjmení',
  labelEmail: 'Email',
  labelCompany: 'Firma',
  labelSubject: 'S čím vám můžeme pomoct?',
  labelMessage: 'Zpráva',
  placeholderFirstName: 'Jan',
  placeholderLastName: 'Novák',
  placeholderEmail: 'jan@firma.cz',
  placeholderCompany: 'Kavárna Vlna',
  placeholderSubject: 'Vyberte téma',
  placeholderMessage: 'Máme 14 brigádníků a rozpis řešíme v Excelu…',
  subjects: [
    'Chci ukázat Ompli naživo',
    'Ceník a nabídka',
    'Jsem už zákazník, potřebuji pomoc',
    'Partnerství',
    'Něco jiného',
  ],
  submit: 'Odeslat zprávu',
  consent:
    'Žádný spam - jen odpověď na váš dotaz. Odesláním souhlasíte se zpracováním údajů pro účely kontaktování.',
  scheduleTitle: 'Nebo si rovnou vyberte termín',
  scheduleSub: '30 minut online, kamera dobrovolná. Ukážeme vám Ompli na vašem rozpisu směn.',
  teamTitle: 'Budete mluvit s',
  team: [
    { name: 'Tereza Malá', role: 'Sales Lead' },
    { name: 'Martin Kolář', role: 'Zákaznická podpora' },
    { name: 'Anna Dvořáková', role: 'Onboarding & školení' },
  ],
  expectTitle: 'Co můžete čekat',
  expect: [
    {
      icon: 'analytics',
      title: 'Živá ukázka Ompli',
      text: 'Projdeme plánování směn, docházku i smlouvy na reálných datech - ne na obrázcích.',
    },
    {
      icon: 'users',
      title: 'Přizpůsobeno vašemu provozu',
      text: 'Řekněte nám, jak dnes rozpis řešíte, a ukážeme jen to, co se vás opravdu týká.',
    },
    {
      icon: 'clock',
      title: '30 minut, bez závazků',
      text: 'Krátké, konkrétní setkání. Žádný prodejní tlak, žádný závazek.',
    },
  ],
  preferTitle: 'Preferujete telefon nebo email?',
  emailLabel: 'Napište nám',
  emailValue: 'ahoj@ompli.cz',
  phoneLabel: 'Zavolejte, Po–Pá 9:00 – 17:00',
  phoneValue: '+420 777 123 456',
  phoneHref: '+420777123456',
  billingTitle: 'Fakturační údaje',
  billingCompany: 'Ompli s.r.o.',
  billing: [
    { k: 'Sídlo', v: 'Karlovo náměstí 10, 120 00 Praha 2' },
    { k: 'IČO', v: '19 284 736' },
    { k: 'DIČ', v: 'CZ19284736' },
    { k: 'Banka', v: '2801847362 / 2010 (Fio banka)' },
    { k: 'Faktury', v: 'fakturace@ompli.cz' },
  ],
  faqTitle: 'Časté dotazy',
  faq: [
    {
      q: 'Jak dlouho trvá demo?',
      a: 'Asi 30 minut. Ukážeme vám Ompli živě a zodpovíme vaše otázky - žádné dlouhé prezentace.',
    },
    {
      q: 'Musím se na něco připravit?',
      a: 'Ne. Stačí přijít. Pokud máte po ruce svůj současný rozpis směn, klidně ho pošlete předem.',
    },
    {
      q: 'Je k dispozici zkušební verze zdarma?',
      a: 'Ano - můžete ji spustit hned po demu, nebo kdykoliv sami na ompli.cz. Bez platební karty.',
    },
    {
      q: 'Můžu pozvat svůj tým?',
      a: 'Samozřejmě. Přiveďte kohokoliv, kdo řeší směny nebo docházku - čím více kontextu, tím lepší demo vám dáme.',
    },
    {
      q: 'Jsme malá firma, vadí to?',
      a: 'Vůbec. Většina našich zákazníků má 5 až 50 brigádníků - přesně pro ně je Ompli stavěné.',
    },
    {
      q: 'Co když mám jen rychlý dotaz?',
      a: 'Napište nám na ahoj@ompli.cz - rádi odpovíme i bez rezervace celého dema.',
    },
  ],
  footerTagline: 'Směny, docházka, smlouvy a nábor v jedné aplikaci pro rostoucí firmy.',
  footerProduct: 'Produkt',
  footerCompany: 'Společnost',
  footerSupport: 'Podpora',
  footerLegal: 'Právní',
  footerShifts: 'Směny',
  footerAttendance: 'Docházka',
  footerContracts: 'Smlouvy',
  footerHiring: 'Nábor',
  footerAbout: 'O nás',
  footerCareers: 'Kariéra',
  footerBlog: 'Blog',
  footerHelp: 'Nápověda',
  footerContact: 'Kontakt',
  footerStatus: 'Stav služby',
  footerGdpr: 'GDPR',
  footerTerms: 'Obchodní podmínky',
  footerCookies: 'Cookies',
  footerPrivacy: 'Ochrana soukromí',
  footerTermsShort: 'Podmínky',
  requiredError: 'Vyplňte prosím povinná pole.',
  sendFailed: 'Odeslání selhalo.',
  sendSuccess: 'Zpráva odeslána. Ozveme se brzy.',
};

const EN: ContactCopy = {
  navFeatures: 'Features',
  navRoles: 'Who it’s for',
  navPricing: 'Pricing',
  navContact: 'Contact',
  navLogin: 'Sign in',
  navCta: 'Try for free',
  mobileWrite: 'Get in touch',
  heroTitleBefore: 'Let’s talk about\nyour ',
  heroTitleHighlight: 'shifts',
  heroSub:
    'Write to us, or pick a time - we reply within 1 business day. No sales pressure, just concrete answers on how Ompli handles your scheduling.',
  heroCtaWrite: 'Get in touch',
  heroCtaSchedule: 'Live chat',
  calendarMonth: 'July',
  calendarBadge: '30 min',
  chatIn: 'We have 14 temps and a roster in Excel. Can Ompli handle that?',
  chatOut: 'Absolutely - I’ll show you on your roster. When works?',
  teamOnlineLabel: 'Our team is online',
  teamOnlineHours: 'Mon–Fri, 9:00 – 17:00',
  formTitle: 'Write to us',
  formSub: 'A few lines about how you schedule shifts today is enough.',
  labelFirstName: 'First name',
  labelLastName: 'Last name',
  labelEmail: 'Email',
  labelCompany: 'Company',
  labelSubject: 'How can we help?',
  labelMessage: 'Message',
  placeholderFirstName: 'John',
  placeholderLastName: 'Doe',
  placeholderEmail: 'john@company.com',
  placeholderCompany: 'Café Wave',
  placeholderSubject: 'Select a topic',
  placeholderMessage: 'We have 14 temps and schedule in Excel…',
  subjects: [
    'I want a live Ompli demo',
    'Pricing and offer',
    'I’m a customer and need help',
    'Partnership',
    'Something else',
  ],
  submit: 'Send message',
  consent:
    'No spam - just a reply to your question. By submitting you agree to processing of your data for contact purposes.',
  scheduleTitle: 'Or pick a time right away',
  scheduleSub: '30 minutes online, camera optional. We’ll show Ompli on your shift roster.',
  teamTitle: 'You’ll be speaking with',
  team: [
    { name: 'Tereza Malá', role: 'Sales Lead' },
    { name: 'Martin Kolář', role: 'Customer support' },
    { name: 'Anna Dvořáková', role: 'Onboarding & training' },
  ],
  expectTitle: 'What to expect',
  expect: [
    {
      icon: 'analytics',
      title: 'Live Ompli walkthrough',
      text: 'We’ll go through scheduling, attendance, and contracts on real data - not screenshots.',
    },
    {
      icon: 'users',
      title: 'Tailored to your operations',
      text: 'Tell us how you schedule today and we’ll show only what matters to you.',
    },
    {
      icon: 'clock',
      title: '30 minutes, no commitment',
      text: 'Short and concrete. No sales pressure, no obligation.',
    },
  ],
  preferTitle: 'Prefer phone or email?',
  emailLabel: 'Write to us',
  emailValue: 'ahoj@ompli.cz',
  phoneLabel: 'Call us, Mon–Fri 9:00 – 17:00',
  phoneValue: '+420 777 123 456',
  phoneHref: '+420777123456',
  billingTitle: 'Billing details',
  billingCompany: 'Ompli s.r.o.',
  billing: [
    { k: 'Seat', v: 'Karlovo náměstí 10, 120 00 Prague 2' },
    { k: 'ID', v: '19 284 736' },
    { k: 'VAT', v: 'CZ19284736' },
    { k: 'Bank', v: '2801847362 / 2010 (Fio banka)' },
    { k: 'Invoices', v: 'fakturace@ompli.cz' },
  ],
  faqTitle: 'FAQ',
  faq: [
    {
      q: 'How long is the demo?',
      a: 'About 30 minutes. We’ll show Ompli live and answer your questions - no long slide decks.',
    },
    {
      q: 'Do I need to prepare anything?',
      a: 'No. Just show up. If you have your current roster handy, feel free to send it ahead.',
    },
    {
      q: 'Is there a free trial?',
      a: 'Yes - start right after the demo, or anytime yourself at ompli.cz. No credit card.',
    },
    {
      q: 'Can I invite my team?',
      a: 'Absolutely. Bring anyone who handles shifts or attendance - more context means a better demo.',
    },
    {
      q: 'We’re a small company - is that OK?',
      a: 'Of course. Most of our customers have 5 to 50 temps - that’s who Ompli is built for.',
    },
    {
      q: 'What if I just have a quick question?',
      a: 'Email us at ahoj@ompli.cz - happy to help without booking a full demo.',
    },
  ],
  footerTagline: 'Shifts, attendance, contracts, and hiring in one app for growing companies.',
  footerProduct: 'Product',
  footerCompany: 'Company',
  footerSupport: 'Support',
  footerLegal: 'Legal',
  footerShifts: 'Shifts',
  footerAttendance: 'Attendance',
  footerContracts: 'Contracts',
  footerHiring: 'Hiring',
  footerAbout: 'About',
  footerCareers: 'Careers',
  footerBlog: 'Blog',
  footerHelp: 'Help',
  footerContact: 'Contact',
  footerStatus: 'Service status',
  footerGdpr: 'GDPR',
  footerTerms: 'Terms of service',
  footerCookies: 'Cookies',
  footerPrivacy: 'Privacy',
  footerTermsShort: 'Terms',
  requiredError: 'Please fill in the required fields.',
  sendFailed: 'Failed to send.',
  sendSuccess: 'Message sent. We will get back to you soon.',
};

export function getContactCopy(lang: 'cs' | 'en'): ContactCopy {
  return lang === 'en' ? EN : CS;
}
